import React from "react";
import loader from "../../assets/images/loader.svg";
import { Spin } from 'antd';


const CircularProgress = ({className}) => <div className={`loader ${className}`}>
  <Spin />
</div>;
export default CircularProgress;
